import DescriptionIcon from '@mui/icons-material/Description';
import GavelIcon from '@mui/icons-material/Gavel';
import Topic from '@mui/icons-material/Topic';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import { Box, List, ListItem, ListItemButton, ListItemIcon, ListItemText, styled } from '@mui/material';
import MuiDrawer from '@mui/material/Drawer';
import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import UserInformation from '../userManagement/UserInformation';
import { Rule, Insights } from '@mui/icons-material';

const DrawerMenuBar = () => {
    const menuItems = [
        {
            text: 'Vertragsübersicht',
            path: '',
            icon: <DescriptionIcon />,
            selectedIcon: <DescriptionIcon sx={{ color: 'white' }} />,
            isSelected: (pathname) => pathname === '/app' || pathname === '/app/' || pathname.startsWith('/app/contract/')
        },
        {
            text: 'Regeln',
            path: '/rules',
            icon: <Rule />,
            selectedIcon: <Rule sx={{ color: 'white' }} />,
            isSelected: (pathname) => pathname.startsWith('/app/rules')
        },
        {
            text: 'Themen',
            path: '/topics',
            icon: <Topic />,
            selectedIcon: <Topic sx={{ color: 'white' }} />,
            isSelected: (pathname) => pathname.startsWith('/app/topics')
        },
        {
            text: 'Nutzerverwaltung',
            path: '/users',
            icon: <PermContactCalendarIcon />,
            selectedIcon: <PermContactCalendarIcon sx={{ color: 'white' }} />,
            isSelected: (pathname) => pathname.startsWith('/app/users')
        },
        {
            text: 'Analysis',
            path: '/analysis',
            icon: <Insights />,
            selectedIcon: <Insights sx={{ color: 'white' }} />,
            isSelected: (pathname) => pathname.startsWith('/app/analysis')
        }
    ];

    const navigate = useNavigate();
    const location = useLocation();

    const drawerWidth = 300;

    const openedMixin = (theme) => ({
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        }),
        overflowX: 'hidden',
        position: 'fixed',
        zIndex: 1200
    });

    const closedMixin = (theme) => ({
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        overflowX: 'hidden',
        width: '65px',
        zIndex: 1
    });

    const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
        ({ theme, open }) => ({
            width: drawerWidth,
            flexShrink: 0,
            whiteSpace: 'nowrap',
            boxSizing: 'border-box',
            borderRadius: '16px',
            ...(open && {
                ...openedMixin(theme),
                '& .MuiDrawer-paper': openedMixin(theme)
            }),
            ...(!open && {
                ...closedMixin(theme),
                '& .MuiDrawer-paper': closedMixin(theme)
            })
        })
    );

    return (
        <>
            <Drawer
                variant="permanent"
                hideBackdrop
            >
                <Box display={'flex'} flexDirection="row" alignItems="center" margin={2} overflow={'hidden'} style={{ cursor: 'pointer' }} >
                    <Link to="/app">
                        <GavelIcon sx={{ mr: 2, fontSize: '40px' }} color='primary' />
                    </Link>
                </Box>
                <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="space-between"
                    height="100%"
                >
                    <List>
                        {menuItems.map((item) => {
                            const isSelected = item.isSelected(location.pathname);

                            return (
                            <ListItem key={item.text} disablePadding sx={{ display: 'block' }}>
                                <ListItemButton
                                    sx={{
                                        minHeight: 48,
                                        justifyContent: 'center',
                                        px: 2.5,
                                        borderRadius: '23px',
                                        backgroundColor: isSelected ? 'primary.main' : 'none',
                                        m: 1,
                                        '&:hover': {
                                            backgroundColor: isSelected ? 'black' : 'default'
                                        }
                                    }}
                                    onClick={() => navigate("/app" + item.path)}
                                >
                                    <ListItemIcon
                                        sx={{
                                            minWidth: 0,
                                            mr: 'auto',
                                            justifyContent: 'center'
                                        }}
                                    >
                                        {isSelected ? item.selectedIcon : item.icon}
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={item.text}
                                        sx={{
                                            opacity: 0,
                                            '& .MuiListItemText-primary': {
                                                fontSize: '1rem',
                                                fontWeight: 500,
                                                color: isSelected ? 'white' : 'black'
                                            }
                                        }} />
                                </ListItemButton>
                            </ListItem>
                            );
                        })}
                    </List>
                    <List>
                        <UserInformation />
                    </List>
                </Box>
            </Drawer>
        </>
    );
};

export default DrawerMenuBar;
